import { BaseType } from '../base/base-type';
import { MemberRetirementTypeIdEnum } from './enum/member-retirement-type-id.enum';

export class RetirementType extends BaseType {
  public declare id: MemberRetirementTypeIdEnum;
}
